import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function InterestBox(props) {
    return (
        <div className="col-lg-3 col-md-4 col-sm-6 col-12 interest-all-box">
            <div className="interest-box1">
                <div className="interest-icon">
                    <FontAwesomeIcon icon={props.Icon} />
                </div>
                <div className="interest-box-title">
                    <h5>{props.title }</h5>
                </div>
            </div>
        </div>
    )
}